var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _path9, _g4, _path0, _path1, _g5, _path10, _g6, _path11, _g7, _g8, _path12, _path13, _g9, _path14, _path15, _g0, _path16, _g1, _path17, _g10, _g11, _path18, _path19, _g12, _path20, _path21, _g13, _path22, _path23, _g14, _path24, _path25, _g15, _path26, _g16, _path27, _g17, _path28, _g18, _path29, _g19, _g20, _path30, _g21, _path31, _g22, _g23, _path32, _path33, _g24, _path34, _g25, _path35, _g26, _g27, _path36, _path37, _g28, _path38, _g29, _path39, _g30, _g31, _path40, _path41, _g32, _path42, _g33, _path43, _g34, _path44, _g35, _g36, _path45, _g37, _path46, _g38, _g39, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g40, _path66, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZebraOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_189528)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.671 312C219.665 312 261.003 306.405 261.003 299.503C261.003 292.6 219.665 287.005 168.671 287.005C117.678 287.005 76.3398 292.6 76.3398 299.503C76.3398 306.405 117.678 312 168.671 312Z",
    fill: "#F0BA9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.231 249.455C224.104 250.243 217.006 248.216 210.472 243.319C205.514 239.547 200.895 234.086 197.684 226.768L191.262 229.976C195.318 238.421 200.951 244.557 206.923 248.723C215.147 254.409 223.935 256.267 230.132 255.085L229.231 249.455Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 191,
    y: 226,
    width: 40,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.231 249.455C224.104 250.243 217.006 248.216 210.472 243.319C205.514 239.547 200.895 234.086 197.684 226.768L191.262 229.976C195.318 238.421 200.951 244.557 206.923 248.723C215.147 254.409 223.935 256.267 230.132 255.085L229.231 249.455Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.528 233.748C196.049 236.338 198.528 238.702 200.612 240.785C206.415 246.527 213.118 250.693 220.836 252.607C222.921 253.114 225.061 253.733 227.258 253.79C227.427 253.79 227.878 254.352 227.991 254.465C228.667 255.028 229.343 255.478 230.075 255.872C232.216 257.055 234.525 257.618 236.948 257.505C242.131 257.336 246.412 254.352 249.792 250.412C250.919 249.117 251.989 247.766 253.059 246.358C253.454 245.795 253.904 245.176 254.299 244.613C254.355 244.557 254.637 244.107 254.749 244.219C254.975 244.501 254.468 245.458 254.355 245.739C253.735 247.372 253.003 248.892 252.158 250.412C248.665 256.604 243.145 261.277 236.103 261.896C232.948 262.178 229.737 261.671 226.864 260.376C225.343 259.701 223.991 258.518 222.47 257.899C219.766 256.886 216.837 256.773 214.132 255.704C205.626 252.27 197.57 245.683 192.895 237.464L194.528 233.748Z",
    fill: "#D0D0D0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.722 258.519C225.737 259.926 221.456 252.72 226.357 248.16C230.638 244.163 238.863 249.737 242.299 240.842C243.37 242.024 243.201 244.839 241.792 246.922C241.792 246.922 243.088 246.134 243.764 244.22C244.046 245.683 243.877 247.316 242.525 249.624C242.525 249.624 243.764 249.005 244.665 249.286C240.44 250.694 240.947 256.886 232.722 258.519Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 240,
    width: 21,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.722 258.519C225.737 259.926 221.456 252.72 226.357 248.16C230.638 244.163 238.863 249.737 242.299 240.842C243.37 242.024 243.201 244.839 241.792 246.922C241.792 246.922 243.088 246.134 243.764 244.22C244.046 245.683 243.877 247.316 242.525 249.624C242.525 249.624 243.764 249.005 244.665 249.286C240.44 250.694 240.947 256.886 232.722 258.519Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.836 255.367L223.765 253.002C228.554 256.662 236.159 254.635 239.708 250.075L237.511 250.694C240.722 248.161 242.468 244.896 243.144 242.7C243.539 241.405 246.355 251.539 245.51 252.552C242.13 256.943 237.173 259.983 231.483 259.758C228.948 259.645 226.413 258.97 224.216 257.675C222.977 257.056 220.836 255.367 220.836 255.367Z",
    fill: "#0D0B0A"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5508 166.249C79.5508 166.249 112.281 194.397 151.095 184.32L146.307 165.742C116.844 173.342 92.1133 151.725 92.1133 151.725L79.5508 166.249Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 151,
    width: 73,
    height: 36
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5508 166.249C79.5508 166.249 112.281 194.397 151.095 184.32L146.307 165.742C116.844 173.342 92.1133 151.725 92.1133 151.725L79.5508 166.249Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9883 169.515C74.9883 169.515 103.324 198.057 146.251 188.261L143.547 178.353C111.887 186.291 83.4947 163.772 83.4947 163.772L74.9883 169.515Z",
    fill: "#D0D0D0"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2821 166.643C65.0719 161.464 61.8045 141.873 74.8177 140.24C79.3244 139.677 85.6338 144.631 88.1125 148.685C87.7182 146.94 87.7182 142.492 90.5349 143.449C91.6616 143.843 93.6333 147.953 93.7459 153.132C91.2672 158.987 85.2395 165.686 80.2821 166.643Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 140,
    width: 28,
    height: 27
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2821 166.643C65.0719 161.464 61.8045 141.873 74.8177 140.24C79.3244 139.677 85.6338 144.631 88.1125 148.685C87.7182 146.94 87.7182 142.492 90.5349 143.449C91.6616 143.843 93.6333 147.953 93.7459 153.132C91.2672 158.987 85.2395 165.686 80.2821 166.643Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7161 166.924C88.505 166.53 76.6749 161.689 74.8722 158.761C69.9711 154.258 67.2108 146.939 75.5482 139.058C63.6617 139.789 60 150.148 60 150.148L79.4353 172.835L91.7161 166.924Z",
    fill: "#0D0B0A"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M158.191 298.545C158.191 298.545 157.572 263.416 163.768 245.514L126.757 232.791C119.095 255.141 119.039 298.883 119.039 298.883L158.191 298.545Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 232,
    width: 45,
    height: 67
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M158.191 298.545C158.191 298.545 157.572 263.416 163.768 245.514L126.757 232.791C119.095 255.141 119.039 298.883 119.039 298.883L158.191 298.545Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.769 298.827C123.995 287.23 125.178 255.141 131.431 237.07L163.034 247.935C163.26 247.09 163.541 246.302 163.823 245.514L126.812 232.791C119.15 255.141 119.094 298.883 119.094 298.883L123.769 298.827Z",
    fill: "#F0F0F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 232,
    width: 45,
    height: 67
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.191 298.545C158.191 298.545 157.572 263.416 163.768 245.514L126.757 232.791C119.095 255.141 119.039 298.883 119.039 298.883L158.191 298.545Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.363 267.188C110.308 267.695 103.885 269.271 103.942 270.735C104.054 272.199 110.646 273.043 118.701 272.537C126.757 272.03 133.179 270.454 133.123 268.99C133.01 267.47 126.419 266.682 118.363 267.188ZM120.335 254.803C112.617 252.495 106.026 251.707 105.575 253.171C105.125 254.578 111.04 257.618 118.758 259.982C126.475 262.291 133.066 263.079 133.517 261.615C133.968 260.208 128.053 257.111 120.335 254.803Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 252,
    width: 15,
    height: 21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 252,
    width: 31,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.363 267.188C110.308 267.695 103.885 269.271 103.942 270.735C104.054 272.199 110.646 273.043 118.701 272.537C126.757 272.03 133.179 270.454 133.123 268.99C133.01 267.47 126.419 266.682 118.363 267.188ZM120.335 254.803C112.617 252.495 106.026 251.707 105.575 253.171C105.125 254.578 111.04 257.618 118.758 259.982C126.475 262.291 133.066 263.079 133.517 261.615C133.968 260.208 128.053 257.111 120.335 254.803Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.191 298.545C158.191 298.545 157.572 263.416 163.768 245.514L126.757 232.791C119.095 255.141 119.039 298.883 119.039 298.883L158.191 298.545Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.769 298.827C123.995 287.23 125.178 255.141 131.431 237.07L163.034 247.935C163.26 247.09 163.541 246.302 163.823 245.514L126.812 232.791C119.15 255.141 119.094 298.883 119.094 298.883L123.769 298.827Z",
    fill: "#666460"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.661 299.615C118.928 299.615 118.252 299.221 117.858 298.602C117.464 297.983 117.464 297.194 117.802 296.519C121.294 290.383 130.646 285.879 140.166 285.879C149.968 285.879 157.01 290.608 159.601 297.026C159.827 297.589 159.77 298.264 159.432 298.771C159.094 299.277 158.531 299.559 157.911 299.559C150.306 299.615 127.829 299.615 119.661 299.615Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 285,
    width: 43,
    height: 15
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.661 299.615C118.928 299.615 118.252 299.221 117.858 298.602C117.464 297.983 117.464 297.194 117.802 296.519C121.294 290.383 130.646 285.879 140.166 285.879C149.968 285.879 157.01 290.608 159.601 297.026C159.827 297.589 159.77 298.264 159.432 298.771C159.094 299.277 158.531 299.559 157.911 299.559C150.306 299.615 127.829 299.615 119.661 299.615Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.28 294.604C116.787 295.393 117.688 295.899 118.702 295.899C128.279 295.899 150.643 295.899 159.375 295.843C160.164 295.843 160.896 295.505 161.347 294.886C161.628 295.28 161.854 295.674 162.079 296.068C162.473 296.8 162.473 297.701 162.023 298.433C161.572 299.165 160.783 299.615 159.882 299.615C150.925 299.671 127.828 299.671 118.026 299.671C116.956 299.671 115.942 299.052 115.491 298.151C114.984 297.194 115.097 296.124 115.773 295.28C115.885 294.999 116.054 294.83 116.28 294.604Z",
    fill: "#0D0B0A"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.147 298.545C179.147 298.545 179.767 263.416 173.57 245.514L210.582 232.791C218.3 255.141 218.3 298.883 218.3 298.883L179.147 298.545Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 232,
    width: 46,
    height: 67
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.147 298.545C179.147 298.545 179.767 263.416 173.57 245.514L210.582 232.791C218.3 255.141 218.3 298.883 218.3 298.883L179.147 298.545Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.624 298.827C213.399 287.23 212.215 255.141 205.962 237.07L174.359 247.935C174.134 247.09 173.852 246.302 173.57 245.514L210.582 232.791C218.3 255.141 218.3 298.883 218.3 298.883L213.624 298.827Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 232,
    width: 46,
    height: 67
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179.147 298.545C179.147 298.545 179.767 263.416 173.57 245.514L210.582 232.791C218.3 255.141 218.3 298.883 218.3 298.883L179.147 298.545Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.033 267.188C227.089 267.695 233.511 269.271 233.455 270.735C233.342 272.199 226.751 273.043 218.695 272.537C210.64 272.03 204.218 270.454 204.274 268.99C204.387 267.47 210.978 266.682 219.033 267.188ZM217.062 254.803C224.78 252.495 231.371 251.707 231.821 253.171C232.272 254.578 226.357 257.618 218.639 259.982C210.921 262.291 204.33 263.079 203.88 261.615C203.429 260.208 209.344 257.111 217.062 254.803Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 252,
    width: 16,
    height: 21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 252,
    width: 31,
    height: 21
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M219.033 267.188C227.089 267.695 233.511 269.271 233.455 270.735C233.342 272.199 226.751 273.043 218.695 272.537C210.64 272.03 204.218 270.454 204.274 268.99C204.387 267.47 210.978 266.682 219.033 267.188ZM217.062 254.803C224.78 252.495 231.371 251.707 231.821 253.171C232.272 254.578 226.357 257.618 218.639 259.982C210.921 262.291 204.33 263.079 203.88 261.615C203.429 260.208 209.344 257.111 217.062 254.803Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.147 298.545C179.147 298.545 179.767 263.416 173.57 245.514L210.582 232.791C218.3 255.141 218.3 298.883 218.3 298.883L179.147 298.545Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.624 298.827C213.399 287.23 212.215 255.141 205.962 237.07L174.359 247.935C174.134 247.09 173.852 246.302 173.57 245.514L210.582 232.791C218.3 255.141 218.3 298.883 218.3 298.883L213.624 298.827Z",
    fill: "#0D0B0A"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M217.736 299.615C218.469 299.615 219.145 299.221 219.539 298.602C219.933 297.983 219.933 297.194 219.595 296.519C216.103 290.383 206.751 285.879 197.231 285.879C187.428 285.879 180.387 290.608 177.795 297.026C177.57 297.589 177.626 298.264 177.964 298.771C178.302 299.277 178.866 299.559 179.485 299.559C187.034 299.615 209.511 299.615 217.736 299.615Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 285,
    width: 43,
    height: 15
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M217.736 299.615C218.469 299.615 219.145 299.221 219.539 298.602C219.933 297.983 219.933 297.194 219.595 296.519C216.103 290.383 206.751 285.879 197.231 285.879C187.428 285.879 180.387 290.608 177.795 297.026C177.57 297.589 177.626 298.264 177.964 298.771C178.302 299.277 178.866 299.559 179.485 299.559C187.034 299.615 209.511 299.615 217.736 299.615Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.061 294.604C220.554 295.393 219.653 295.899 218.639 295.899C209.062 295.899 186.698 295.899 177.966 295.843C177.177 295.843 176.445 295.505 175.994 294.886C175.712 295.28 175.487 295.674 175.262 296.068C174.867 296.8 174.867 297.701 175.318 298.433C175.769 299.165 176.557 299.615 177.459 299.615C186.416 299.671 209.513 299.671 219.315 299.671C220.385 299.671 221.399 299.052 221.85 298.151C222.357 297.194 222.188 296.124 221.568 295.28C221.456 294.999 221.287 294.83 221.061 294.604Z",
    fill: "#0D0B0A"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M224.384 218.66C224.384 218.66 198.019 181.899 183.598 172.16L194.357 157.072C210.244 167.825 239.763 208.077 239.763 208.077L224.384 218.66Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 157,
    width: 57,
    height: 62
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M224.384 218.66C224.384 218.66 198.019 181.899 183.598 172.16L194.357 157.072C210.244 167.825 239.763 208.077 239.763 208.077L224.384 218.66Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.948 223.952C220.948 223.952 185.119 180.492 170.754 170.809L179.091 162.364C194.978 173.117 228.778 217.478 228.778 217.478L220.948 223.952Z",
    fill: "#D0D0D0"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M239.483 207.852C253.228 215.283 252.946 234.255 240.159 233.635C235.708 233.41 230.469 227.668 228.835 223.446C228.892 225.135 228.159 229.357 225.568 227.949C224.554 227.386 223.371 223.22 224.16 218.323C227.596 213.2 234.581 207.908 239.483 207.852Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 207,
    width: 27,
    height: 27
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M239.483 207.852C253.228 215.283 252.946 234.255 240.159 233.635C235.708 233.41 230.469 227.668 228.835 223.446C228.892 225.135 228.159 229.357 225.568 227.949C224.554 227.386 223.371 223.22 224.16 218.323C227.596 213.2 234.581 207.908 239.483 207.852Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.077 213.931C225.964 213.819 229.851 217.59 231.034 220.687C235.653 231.833 246.526 236.112 251.145 223.952C250.582 234.367 239.822 238.307 233.738 237.069C227.372 235.718 222.584 230.201 220.781 224.008C220.049 221.531 219.711 218.716 220.556 216.183L226.077 213.931Z",
    fill: "#0D0B0A"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M199.994 158.029H137.35C130.14 182.349 124.562 206.5 124.562 222.939C124.562 251.875 144.223 266.963 168.559 266.963C192.896 266.963 212.725 251.932 212.725 222.939C212.782 206.557 207.205 182.406 199.994 158.029Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 158,
    width: 89,
    height: 109
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M199.994 158.029H137.35C130.14 182.349 124.562 206.5 124.562 222.939C124.562 251.875 144.223 266.963 168.559 266.963C192.896 266.963 212.725 251.932 212.725 222.939C212.782 206.557 207.205 182.406 199.994 158.029Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.758 158.029H137.35C130.14 182.349 124.562 206.5 124.562 222.939C124.562 235.774 128.45 247.54 134.928 256.66C131.266 248.441 129.182 238.983 129.182 228.906C129.238 212.58 134.534 183.419 142.758 158.029Z",
    fill: "#F0F0F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 158,
    width: 89,
    height: 109
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M199.994 158.029H137.35C130.14 182.349 124.562 206.5 124.562 222.939C124.562 251.875 144.223 266.963 168.559 266.963C192.896 266.963 212.725 251.932 212.725 222.939C212.782 206.557 207.205 182.406 199.994 158.029Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.586 158.029H199.994C207.205 182.349 212.782 206.5 212.782 222.939C212.782 235.774 208.895 247.54 202.416 256.66C206.078 248.441 208.162 238.983 208.162 228.906C208.162 212.58 202.867 183.419 194.586 158.029Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 158,
    width: 89,
    height: 109
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M199.994 158.029H137.35C130.14 182.349 124.562 206.5 124.562 222.939C124.562 251.875 144.223 266.963 168.559 266.963C192.896 266.963 212.725 251.932 212.725 222.939C212.782 206.557 207.205 182.406 199.994 158.029Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.855 144.969C186.305 163.209 192.953 200.308 192.953 212.862C192.953 231.158 182.756 242.587 168.729 242.587C154.702 242.587 144.055 231.158 144.055 212.862C144.055 200.308 150.646 163.209 155.096 144.969H181.855Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 158,
    width: 89,
    height: 109
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M199.994 158.029H137.35C130.14 182.349 124.562 206.5 124.562 222.939C124.562 251.875 144.223 266.963 168.559 266.963C192.896 266.963 212.725 251.932 212.725 222.939C212.782 206.557 207.205 182.406 199.994 158.029Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.487 211.623C224.613 212.749 231.88 214.888 231.655 216.408C231.486 217.928 223.937 218.266 214.811 217.084C205.685 215.958 198.418 213.819 198.643 212.299C198.812 210.779 206.361 210.497 215.487 211.623ZM215.036 199.35C224.219 198.675 231.711 199.35 231.824 200.87C231.937 202.39 224.613 204.192 215.431 204.867C206.248 205.543 198.756 204.867 198.643 203.347C198.53 201.884 205.854 200.082 215.036 199.35ZM213.966 186.177C222.923 184.15 230.472 183.756 230.81 185.22C231.148 186.684 224.162 189.555 215.149 191.582C206.192 193.608 198.643 194.002 198.305 192.539C198.023 191.019 205.009 188.204 213.966 186.177Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 184,
    width: 15,
    height: 34
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 184,
    width: 34,
    height: 34
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M215.483 211.624C224.609 212.75 231.876 214.889 231.651 216.409C231.482 217.929 223.933 218.267 214.807 217.085C205.681 215.959 198.414 213.82 198.639 212.3C198.808 210.78 206.357 210.498 215.483 211.624ZM215.032 199.351C224.215 198.676 231.707 199.351 231.82 200.871C231.933 202.391 224.609 204.193 215.427 204.868C206.244 205.544 198.752 204.868 198.639 203.348C198.527 201.885 205.85 200.083 215.032 199.351ZM213.962 186.178C222.919 184.151 230.468 183.757 230.806 185.221C231.144 186.685 224.159 189.556 215.145 191.582C206.188 193.609 198.639 194.003 198.301 192.54C198.02 191.02 205.005 188.205 213.962 186.178Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.99 158.03H137.346C130.136 182.35 124.559 206.501 124.559 222.94C124.559 251.876 144.219 266.964 168.556 266.964C192.892 266.964 212.721 251.932 212.721 222.94C212.778 206.558 207.201 182.407 199.99 158.03Z",
    fill: "white"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.582 158.03H199.99C207.201 182.35 212.778 206.501 212.778 222.94C212.778 235.775 208.891 247.541 202.412 256.661C206.074 248.442 208.159 238.984 208.159 228.907C208.159 212.581 202.863 183.42 194.582 158.03Z",
    fill: "#0D0B0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 158,
    width: 89,
    height: 109
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M199.994 158.029H137.35C130.14 182.349 124.562 206.5 124.562 222.939C124.562 251.875 144.223 266.963 168.559 266.963C192.896 266.963 212.725 251.932 212.725 222.939C212.782 206.557 207.205 182.406 199.994 158.029Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.463 211.623C112.337 212.749 105.07 214.888 105.295 216.408C105.464 217.928 113.013 218.266 122.139 217.084C131.265 215.958 138.532 213.819 138.307 212.299C138.138 210.779 130.533 210.497 121.463 211.623ZM121.914 199.35C112.731 198.675 105.239 199.35 105.126 200.87C105.014 202.39 112.337 204.192 121.52 204.867C130.702 205.543 138.194 204.867 138.307 203.347C138.42 201.884 131.096 200.082 121.914 199.35ZM122.928 186.177C113.971 184.15 106.422 183.756 106.084 185.22C105.746 186.684 112.731 189.555 121.745 191.582C130.702 193.608 138.251 194.002 138.589 192.539C138.927 191.019 131.941 188.204 122.928 186.177Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 184,
    width: 15,
    height: 34
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 184,
    width: 34,
    height: 34
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.463 211.624C112.337 212.75 105.07 214.889 105.295 216.409C105.464 217.929 113.013 218.267 122.139 217.085C131.265 215.959 138.532 213.82 138.307 212.3C138.138 210.78 130.533 210.498 121.463 211.624ZM121.914 199.351C112.731 198.676 105.239 199.351 105.126 200.871C105.014 202.391 112.337 204.193 121.52 204.868C130.702 205.544 138.194 204.868 138.307 203.348C138.42 201.885 131.096 200.083 121.914 199.351ZM122.928 186.178C113.971 184.151 106.422 183.757 106.084 185.221C105.746 186.685 112.731 189.556 121.745 191.582C130.702 193.609 138.251 194.003 138.589 192.54C138.927 191.02 131.941 188.205 122.928 186.178Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.994 158.03H137.35C130.14 182.35 124.562 206.501 124.562 222.94C124.562 251.876 144.223 266.964 168.559 266.964C192.896 266.964 212.725 251.932 212.725 222.94C212.782 206.558 207.205 182.407 199.994 158.03Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.758 158.03H137.35C130.14 182.35 124.562 206.501 124.562 222.94C124.562 235.775 128.45 247.541 134.928 256.661C131.266 248.442 129.182 238.984 129.182 228.907C129.238 212.581 134.534 183.42 142.758 158.03Z",
    fill: "#666460"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M241.173 30.969C242.356 31.1942 243.201 32.3201 243.089 33.5023C241.568 50.6727 223.766 65.8164 206.753 63.6209L200.895 56.9779C204.556 37.2742 223.935 27.4786 241.173 30.969Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 30,
    width: 44,
    height: 34
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M241.173 30.969C242.356 31.1942 243.201 32.3201 243.089 33.5023C241.568 50.6727 223.766 65.8164 206.753 63.6209L200.895 56.9779C204.556 37.2742 223.935 27.4786 241.173 30.969Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.738 51.2354L205.738 45.9998C205.738 45.9998 211.991 48.8146 219.315 56.0768C220.61 57.3717 222.638 57.6531 224.272 56.8087C229.793 53.7687 241.51 45.7746 244.947 30.7998C244.947 30.7998 244.834 57.9909 216.554 67.2235C216.554 67.2798 213.625 58.1598 201.738 51.2354Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 30,
    width: 44,
    height: 34
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M241.173 30.969C242.356 31.1942 243.201 32.3201 243.089 33.5023C241.568 50.6727 223.766 65.8164 206.753 63.6209L200.895 56.9779C204.556 37.2742 223.935 27.4786 241.173 30.969Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.23 55.3449C205.23 55.3449 211.991 39.2442 231.877 40.2012C232.327 40.2012 232.722 40.4264 233.003 40.7642C233.285 41.1019 233.341 41.5523 233.229 42.0027C231.933 46.3938 227.144 57.8782 211.484 59.8486L205.23 55.3449Z",
    fill: "#F7D8C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 40,
    width: 29,
    height: 20
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 40,
    width: 29,
    height: 20
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M205.23 55.3449C205.23 55.3449 211.991 39.2442 231.877 40.2012C232.327 40.2012 232.722 40.4264 233.003 40.7642C233.285 41.1019 233.341 41.5523 233.229 42.0027C231.933 46.3938 227.144 57.8782 211.484 59.8486L205.23 55.3449Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.173 30.969C242.356 31.1942 243.201 32.3201 243.089 33.5023C241.568 50.6727 223.766 65.8164 206.753 63.6209L200.895 56.9779C204.556 37.2742 223.935 27.4786 241.173 30.969Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.738 51.2354L205.738 45.9998C205.738 45.9998 211.991 48.8146 219.315 56.0768C220.61 57.3717 222.638 57.6531 224.272 56.8087C229.793 53.7687 241.51 45.7746 244.947 30.7998C244.947 30.7998 244.834 57.9909 216.554 67.2235C216.554 67.2798 213.625 58.1598 201.738 51.2354Z",
    fill: "#F0BA9E"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1676 30.969C94.9846 31.1942 94.1396 32.3201 94.2523 33.5023C95.7733 50.6727 113.575 65.8164 130.588 63.6209L136.446 56.9779C132.785 37.2742 113.462 27.4786 96.1676 30.969Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 30,
    width: 43,
    height: 34
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1676 30.969C94.9846 31.1942 94.1396 32.3201 94.2523 33.5023C95.7733 50.6727 113.575 65.8164 130.588 63.6209L136.446 56.9779C132.785 37.2742 113.462 27.4786 96.1676 30.969Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.603 51.2354L131.603 45.9998C131.603 45.9998 125.35 48.8146 118.027 56.0768C116.731 57.3717 114.703 57.6531 113.069 56.8087C107.548 53.7687 95.8309 45.7746 92.3945 30.7998C92.3945 30.7998 92.5072 57.9909 120.787 67.2235C120.843 67.2798 123.716 58.1598 135.603 51.2354Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 30,
    width: 43,
    height: 34
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1676 30.969C94.9846 31.1942 94.1396 32.3201 94.2523 33.5023C95.7733 50.6727 113.575 65.8164 130.588 63.6209L136.446 56.9779C132.785 37.2742 113.462 27.4786 96.1676 30.969Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.107 55.3449C132.107 55.3449 125.347 39.2442 105.461 40.2012C105.01 40.2012 104.616 40.4264 104.334 40.7642C104.053 41.1019 103.996 41.5523 104.109 42.0027C105.405 46.3375 110.25 57.8782 125.91 59.7923L132.107 55.3449Z",
    fill: "#F7D8C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 40,
    width: 29,
    height: 20
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 40,
    width: 29,
    height: 20
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M132.111 55.3449C132.111 55.3449 125.351 39.2442 105.465 40.2012C105.014 40.2012 104.62 40.4264 104.338 40.7642C104.057 41.1019 104 41.5523 104.113 42.0027C105.409 46.3375 110.253 57.8782 125.914 59.7923L132.111 55.3449Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.1715 30.969C94.9885 31.1942 94.1435 32.3201 94.2562 33.5023C95.7772 50.6727 113.579 65.8164 130.592 63.6209L136.45 56.9779C132.789 37.2742 113.466 27.4786 96.1715 30.969Z",
    fill: "white"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.603 51.2354L131.603 45.9998C131.603 45.9998 125.35 48.8146 118.027 56.0768C116.731 57.3717 114.703 57.6531 113.069 56.8087C107.548 53.7687 95.8309 45.7746 92.3945 30.7998C92.3945 30.7998 92.5072 57.9909 120.787 67.2235C120.843 67.2798 123.716 58.1598 135.603 51.2354Z",
    fill: "#F0BA9E"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M168.445 177.339C146.644 176.777 115.435 165.348 107.548 114.625C102.196 80.5662 115.717 52.418 141.574 40.0891C163.037 29.6743 184.782 32.9958 197.401 40.8773C222.188 53.6002 235.032 81.2417 229.85 114.625C221.906 165.517 190.472 176.833 168.671 177.339H168.445Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 33,
    width: 125,
    height: 145
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M168.445 177.339C146.644 176.777 115.435 165.348 107.548 114.625C102.196 80.5662 115.717 52.418 141.574 40.0891C163.037 29.6743 184.782 32.9958 197.401 40.8773C222.188 53.6002 235.032 81.2417 229.85 114.625C221.906 165.517 190.472 176.833 168.671 177.339H168.445Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.703 74.3739C116.28 59.1176 126.927 47.0702 141.574 40.1458C163.037 29.731 184.782 33.0524 197.401 40.9339C211.203 48.0272 221.231 59.6806 226.582 74.3739C220.836 61.3132 211.034 50.8984 198.077 44.4243C185.12 36.5428 162.868 33.2213 140.842 43.6361C127.096 49.9976 116.731 60.7502 110.703 74.3739Z",
    fill: "#F0F0F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 33,
    width: 125,
    height: 145
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M168.445 177.339C146.644 176.777 115.435 165.348 107.548 114.625C102.196 80.5662 115.717 52.418 141.574 40.0891C163.037 29.6743 184.782 32.9958 197.401 40.8773C222.188 53.6002 235.032 81.2417 229.85 114.625C221.906 165.517 190.472 176.833 168.671 177.339H168.445Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.832 84.9014C106.761 92.8391 106.818 101.396 108.226 110.404C116 161.127 146.928 172.498 168.447 173.118H168.673C190.249 172.611 221.345 161.295 229.175 110.404C230.527 101.452 230.64 92.8954 229.57 84.9014C231.372 94.0214 231.541 104.042 229.851 114.626C221.908 165.518 190.474 176.833 168.673 177.34H168.391C146.59 176.777 115.381 165.349 107.494 114.626C105.86 104.042 106.029 94.0777 107.832 84.9014Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 33,
    width: 125,
    height: 145
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M168.445 177.339C146.644 176.777 115.435 165.348 107.548 114.625C102.196 80.5662 115.717 52.418 141.574 40.0891C163.037 29.6743 184.782 32.9958 197.401 40.8773C222.188 53.6002 235.032 81.2417 229.85 114.625C221.906 165.517 190.472 176.833 168.671 177.339H168.445Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.623 149.078C241.116 150.092 233.736 147.502 225.061 143.336C216.385 139.17 209.738 134.948 210.245 133.991C210.752 132.978 218.132 135.567 226.807 139.733C235.426 143.843 242.074 148.065 241.623 149.078ZM95.7739 149.078C96.2809 150.092 103.661 147.502 112.336 143.336C121.012 139.17 127.659 134.948 127.152 133.991C126.645 132.978 119.265 135.567 110.59 139.733C101.914 143.899 95.2669 148.065 95.7739 149.078ZM243.764 143.393C243.2 144.518 234.975 141.647 225.399 137.031C215.822 132.415 208.442 127.742 208.949 126.616C209.512 125.49 217.737 128.361 227.314 132.978C236.947 137.65 244.327 142.267 243.764 143.393ZM93.5769 143.393C94.1402 144.518 102.365 141.647 111.942 137.031C121.519 132.415 128.898 127.742 128.391 126.616C127.828 125.49 119.603 128.361 110.026 132.978C100.393 137.65 93.0135 142.267 93.5769 143.393ZM248.327 138.833C247.82 139.846 240.44 137.256 231.764 133.09C223.089 128.924 216.442 124.702 216.949 123.745C217.456 122.732 224.835 125.321 233.511 129.487C242.13 133.597 248.777 137.819 248.327 138.833ZM89.0701 138.833C89.5772 139.846 96.9569 137.256 105.632 133.09C114.308 128.924 120.955 124.702 120.448 123.745C119.941 122.732 112.561 125.321 103.886 129.487C95.2106 133.597 88.5631 137.819 89.0701 138.833Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 123,
    width: 125,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 123,
    width: 160,
    height: 27
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M241.623 149.078C241.116 150.092 233.736 147.502 225.061 143.336C216.385 139.17 209.738 134.948 210.245 133.991C210.752 132.978 218.132 135.567 226.807 139.733C235.426 143.843 242.074 148.065 241.623 149.078ZM95.7739 149.078C96.2809 150.092 103.661 147.502 112.336 143.336C121.012 139.17 127.659 134.948 127.152 133.991C126.645 132.978 119.265 135.567 110.59 139.733C101.914 143.899 95.2669 148.065 95.7739 149.078ZM243.764 143.393C243.2 144.518 234.975 141.647 225.399 137.031C215.822 132.415 208.442 127.742 208.949 126.616C209.512 125.49 217.737 128.361 227.314 132.978C236.947 137.65 244.327 142.267 243.764 143.393ZM93.5769 143.393C94.1402 144.518 102.365 141.647 111.942 137.031C121.519 132.415 128.898 127.742 128.391 126.616C127.828 125.49 119.603 128.361 110.026 132.978C100.393 137.65 93.0135 142.267 93.5769 143.393ZM248.327 138.833C247.82 139.846 240.44 137.256 231.764 133.09C223.089 128.924 216.442 124.702 216.949 123.745C217.456 122.732 224.835 125.321 233.511 129.487C242.13 133.597 248.777 137.819 248.327 138.833ZM89.0701 138.833C89.5772 139.846 96.9569 137.256 105.632 133.09C114.308 128.924 120.955 124.702 120.448 123.745C119.941 122.732 112.561 125.321 103.886 129.487C95.2106 133.597 88.5631 137.819 89.0701 138.833Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.445 177.339C146.644 176.777 115.435 165.348 107.548 114.625C102.196 80.5662 115.717 52.418 141.574 40.0891C163.037 29.6743 184.782 32.9958 197.401 40.8773C222.188 53.6002 235.032 81.2417 229.85 114.625C221.906 165.517 190.472 176.833 168.671 177.339H168.445Z",
    fill: "white"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.828 84.9004C106.758 92.8382 106.814 101.395 108.222 110.403C115.996 161.126 146.924 172.497 168.443 173.117H168.669C190.245 172.61 221.341 161.294 229.172 110.403C230.524 101.451 230.636 92.8945 229.566 84.9004C231.369 94.0204 231.538 104.041 229.848 114.625C221.904 165.517 190.47 176.832 168.669 177.339H168.387C146.586 176.776 115.377 165.348 107.49 114.625C105.856 104.041 106.025 94.0767 107.828 84.9004Z",
    fill: "#0D0B0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 33,
    width: 125,
    height: 145
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M168.445 177.339C146.644 176.777 115.435 165.348 107.548 114.625C102.196 80.5662 115.717 52.418 141.574 40.0891C163.037 29.6743 184.782 32.9958 197.401 40.8773C222.188 53.6002 235.032 81.2417 229.85 114.625C221.906 165.517 190.472 176.833 168.671 177.339H168.445Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.612 32.0388C217.739 32.827 214.077 39.6388 208.556 47.1825C202.979 54.7262 197.571 60.187 196.501 59.3425C195.374 58.5544 198.979 51.7425 204.557 44.1988C210.077 36.7114 215.485 31.2507 216.612 32.0388ZM120.788 32.0388C119.661 32.827 123.266 39.6388 128.844 47.1825C134.421 54.7262 139.829 60.187 140.899 59.3425C142.026 58.5544 138.42 51.7425 132.843 44.1988C127.266 36.7114 121.858 31.2507 120.788 32.0388ZM224.161 42.1722C224.837 43.0729 220.612 47.5766 214.64 52.2492C208.669 56.9218 203.261 60.0181 202.585 59.1174C201.909 58.2166 206.134 53.7129 212.105 49.0403C218.02 44.3114 223.428 41.2714 224.161 42.1722ZM113.239 42.1722C112.563 43.0729 116.788 47.5766 122.759 52.2492C128.731 56.9218 134.139 60.0181 134.815 59.1174C135.491 58.2166 131.266 53.7129 125.294 49.0403C119.323 44.3114 113.915 41.2714 113.239 42.1722ZM202.979 28.7736C204.05 29.1677 202.867 35.2477 200.331 42.3974C197.796 49.547 194.867 55.0077 193.797 54.6699C192.726 54.2759 193.909 48.1959 196.444 41.0462C198.979 33.8966 201.909 28.4359 202.979 28.7736ZM134.364 28.7736C133.294 29.1677 134.477 35.2477 137.012 42.3974C139.547 49.547 142.42 55.0077 143.547 54.6699C144.617 54.2759 143.434 48.1959 140.899 41.0462C138.364 33.8966 135.435 28.4359 134.364 28.7736Z",
    fill: "#0D0B0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 33,
    width: 112,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 28,
    width: 112,
    height: 32
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M216.612 32.0388C217.739 32.827 214.077 39.6388 208.556 47.1825C202.979 54.7262 197.571 60.187 196.501 59.3425C195.374 58.5544 198.979 51.7425 204.557 44.1988C210.077 36.7114 215.485 31.2507 216.612 32.0388ZM120.788 32.0388C119.661 32.827 123.266 39.6388 128.844 47.1825C134.421 54.7262 139.829 60.187 140.899 59.3425C142.026 58.5544 138.42 51.7425 132.843 44.1988C127.266 36.7114 121.858 31.2507 120.788 32.0388ZM224.161 42.1722C224.837 43.0729 220.612 47.5766 214.64 52.2492C208.669 56.9218 203.261 60.0181 202.585 59.1174C201.909 58.2166 206.134 53.7129 212.105 49.0403C218.02 44.3114 223.428 41.2714 224.161 42.1722ZM113.239 42.1722C112.563 43.0729 116.788 47.5766 122.759 52.2492C128.731 56.9218 134.139 60.0181 134.815 59.1174C135.491 58.2166 131.266 53.7129 125.294 49.0403C119.323 44.3114 113.915 41.2714 113.239 42.1722ZM202.979 28.7736C204.05 29.1677 202.867 35.2477 200.331 42.3974C197.796 49.547 194.867 55.0077 193.797 54.6699C192.726 54.2759 193.909 48.1959 196.444 41.0462C198.979 33.8966 201.909 28.4359 202.979 28.7736ZM134.364 28.7736C133.294 29.1677 134.477 35.2477 137.012 42.3974C139.547 49.547 142.42 55.0077 143.547 54.6699C144.617 54.2759 143.434 48.1959 140.899 41.0462C138.364 33.8966 135.435 28.4359 134.364 28.7736Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.445 177.339C146.644 176.777 115.435 165.348 107.548 114.625C102.196 80.5662 115.717 52.418 141.574 40.0891C163.037 29.6743 184.782 32.9958 197.401 40.8773C222.188 53.6002 235.032 81.2417 229.85 114.625C221.906 165.517 190.472 176.833 168.671 177.339H168.445Z",
    fill: "white"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.703 74.3739C116.28 59.1176 126.927 47.0702 141.574 40.1458C163.037 29.731 184.782 33.0524 197.401 40.9339C211.203 48.0272 221.231 59.6806 226.582 74.3739C220.836 61.3132 211.034 50.8984 198.077 44.4243C185.12 36.5428 162.868 33.2213 140.842 43.6361C127.096 49.9976 116.731 60.7502 110.703 74.3739Z",
    fill: "#666460"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.67 119.86C191.429 119.86 209.907 134.272 209.907 152.006C209.907 169.739 194.922 184.151 168.67 184.151C142.418 184.151 127.434 169.739 127.434 152.006C127.49 134.272 145.911 119.86 168.67 119.86Z",
    fill: "#9A9895"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.449 136.693C139.435 126.672 153.067 119.86 168.728 119.86C184.389 119.86 198.022 126.672 205.008 136.693C196.839 128.699 183.657 123.463 168.728 123.463C153.8 123.52 140.618 128.699 132.449 136.693Z",
    fill: "#C1BFBD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.602 154.877C131.77 168.501 146.192 178.521 168.669 178.521C191.146 178.521 205.568 168.501 209.737 154.877C208.216 171.315 193.456 184.207 168.669 184.207C143.882 184.151 129.123 171.259 127.602 154.877Z",
    fill: "#64615E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.794 121.831C197.061 122.901 198.695 126.391 197.455 129.713C196.216 133.034 192.554 134.892 189.287 133.823C186.02 132.753 184.386 129.263 185.625 125.941C186.865 122.62 190.526 120.818 193.794 121.831Z",
    fill: "#9A9895"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.443 125.266C194.358 125.885 195.316 127.968 194.64 129.882C193.907 131.796 191.26 133.766 189.006 132.978C189.964 130.67 187.767 130.839 188.161 128.137C188.499 126.11 190.527 124.646 192.443 125.266Z",
    fill: "#2F2D2A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.545 121.831C140.277 122.901 138.644 126.391 139.883 129.713C141.122 133.034 144.784 134.892 148.052 133.823C151.319 132.753 152.953 129.263 151.713 125.941C150.474 122.62 146.812 120.818 143.545 121.831Z",
    fill: "#9A9895"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.898 125.266C142.982 125.885 142.025 127.968 142.701 129.882C143.433 131.796 146.081 133.766 148.334 132.978C147.376 130.67 149.573 130.839 149.179 128.137C148.841 126.11 146.869 124.646 144.898 125.266Z",
    fill: "#2F2D2A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.008 76.4561C153.515 76.4561 160.387 83.4368 160.387 92.0501C160.387 100.663 153.515 107.644 145.008 107.644C136.502 107.644 129.629 100.663 129.629 92.0501C129.629 83.4368 136.502 76.4561 145.008 76.4561Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.011 81.8047C151.208 81.8047 156.222 86.8713 156.222 93.1202C156.222 99.3691 151.208 104.436 145.011 104.436C138.815 104.436 133.801 99.3691 133.801 93.1202C133.801 86.8713 138.815 81.8047 145.011 81.8047Z",
    fill: "#0D0B0A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.322 85.126C148.167 84.5068 149.857 85.4075 151.152 87.1527C152.448 88.8979 152.842 90.8119 151.997 91.4312C151.152 92.0505 149.462 91.1497 148.167 89.4045C146.871 87.7157 146.477 85.7453 147.322 85.126Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.276 93.3457C153.234 93.3457 153.966 94.1339 153.966 95.0346C153.966 95.9353 153.234 96.7235 152.276 96.7235C151.318 96.7235 150.586 95.9353 150.586 95.0346C150.586 94.1339 151.318 93.3457 152.276 93.3457Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.387 76.4561C200.893 76.4561 207.766 83.4368 207.766 92.0501C207.766 100.663 200.893 107.644 192.387 107.644C183.881 107.644 177.008 100.663 177.008 92.0501C177.008 83.4368 183.881 76.4561 192.387 76.4561Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.386 81.8047C198.583 81.8047 203.597 86.8713 203.597 93.1202C203.597 99.3691 198.583 104.436 192.386 104.436C186.19 104.436 181.176 99.3691 181.176 93.1202C181.176 86.8713 186.19 81.8047 192.386 81.8047Z",
    fill: "#0D0B0A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.697 85.126C195.542 84.5068 197.232 85.4075 198.527 87.1527C199.823 88.8979 200.217 90.8119 199.372 91.4312C198.527 92.0505 196.837 91.1497 195.542 89.4045C194.246 87.7157 193.852 85.7453 194.697 85.126Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.655 93.3457C200.613 93.3457 201.345 94.1339 201.345 95.0346C201.345 95.9353 200.613 96.7235 199.655 96.7235C198.697 96.7235 197.965 95.9353 197.965 95.0346C197.965 94.1339 198.697 93.3457 199.655 93.3457Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.519 110.009C130.363 110.009 134.307 111.867 134.307 114.175C134.307 116.483 130.363 118.341 125.519 118.341C120.674 118.341 116.73 116.483 116.73 114.175C116.73 111.867 120.674 110.009 125.519 110.009Z",
    fill: "#ED8181"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.823 110.009C216.668 110.009 220.611 111.867 220.611 114.175C220.611 116.483 216.668 118.341 211.823 118.341C206.979 118.341 203.035 116.483 203.035 114.175C203.035 111.867 206.979 110.009 211.823 110.009Z",
    fill: "#ED8181"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M193.175 42.7348C188.274 34.403 183.091 28.4356 175.035 25.5082C174.923 25.4519 174.754 25.5082 174.641 25.6208C174.528 25.7334 174.528 25.9022 174.641 26.0148C175.373 27.1408 176.669 29.28 178.134 32.2074C174.923 30.9126 164.839 19.7097 164.501 13.6297C164.501 13.4608 164.444 13.2919 164.275 13.2356C164.106 13.1793 163.937 13.1793 163.825 13.2356C161.515 15.8815 158.36 25.0578 160.388 31.9822C160.388 31.9822 153.91 30.406 148.784 22.7497C148.615 22.5245 148.389 22.4119 148.108 22.4119C147.826 22.4119 147.601 22.5808 147.488 22.806C146.08 26.6341 147.601 36.2608 153.29 41.3274L193.175 42.7348Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_198_189528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 13,
    width: 48,
    height: 30
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M193.175 42.7348C188.274 34.403 183.091 28.4356 175.035 25.5082C174.923 25.4519 174.754 25.5082 174.641 25.6208C174.528 25.7334 174.528 25.9022 174.641 26.0148C175.373 27.1408 176.669 29.28 178.134 32.2074C174.923 30.9126 164.839 19.7097 164.501 13.6297C164.501 13.4608 164.444 13.2919 164.275 13.2356C164.106 13.1793 163.937 13.1793 163.825 13.2356C161.515 15.8815 158.36 25.0578 160.388 31.9822C160.388 31.9822 153.91 30.406 148.784 22.7497C148.615 22.5245 148.389 22.4119 148.108 22.4119C147.826 22.4119 147.601 22.5808 147.488 22.806C146.08 26.6341 147.601 36.2608 153.29 41.3274L193.175 42.7348Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_198_189528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.188 25.0014C174.188 25.0014 174.414 25.3392 174.414 25.3955C174.695 25.7896 174.977 26.24 175.259 26.634C176.498 28.3792 177.906 30.1244 179.371 31.6444C179.822 32.0948 180.216 32.5451 180.667 32.9392C180.723 32.9955 181.061 33.277 181.005 33.3896C180.836 33.5585 179.596 32.8829 179.427 32.8266C177.737 32.0385 176.329 30.9688 175.033 29.6177C172.724 27.1407 170.865 24.2696 169.175 21.3422C167.372 18.1333 165.682 14.5303 165.344 10.8148C165.344 10.7022 165.062 10.9274 165.006 10.9274C164.781 11.04 164.555 11.2088 164.33 11.3214C163.767 11.7155 163.203 12.2785 162.696 12.7851C161.175 14.474 159.936 16.557 159.541 18.8088C158.809 22.6933 159.485 27.5911 161.682 30.9125C163.034 32.9392 164.95 34.4029 167.034 35.5288C166.978 35.4725 166.64 35.4162 166.583 35.36C166.133 35.1911 165.738 35.0222 165.288 34.8533C163.823 34.234 162.358 33.5585 161.006 32.7703C157.457 30.7437 154.866 27.9288 152.95 24.3822C153.007 24.4385 152.894 24.2696 152.838 24.157C152.725 24.0444 152.669 23.8755 152.556 23.7066C152.331 23.3125 152.049 22.9185 151.824 22.5244C151.26 21.6237 150.19 19.2592 148.894 19.3718C148.162 19.4281 147.486 20.0474 147.035 20.554C145.74 22.074 145.345 24.3822 145.402 26.2962C145.458 28.154 146.303 29.7866 147.204 31.4192C148.5 33.7274 149.908 36.0355 151.88 37.7807C152.894 38.7377 154.021 39.4696 155.26 40.1451C155.654 40.3703 156.049 40.5955 156.499 40.7644C156.556 40.7644 157.119 40.9896 157.119 41.0459C157.063 41.1022 156.725 41.0459 156.668 41.0459C156.218 41.0459 155.767 41.0459 155.373 41.0459C153.401 40.9896 151.486 40.5392 149.796 39.4133C146.528 37.274 144.275 33.5022 142.698 30.0118C141.74 27.8725 141.008 25.5644 141.402 23.2562C142.754 14.7555 151.035 8.61921 159.316 8.05625C167.09 7.54958 175.371 12.6162 175.935 20.9481L174.188 25.0014Z",
    fill: "#D0D0D0"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.221 159.099C157.291 160.676 158.868 161.858 161.009 162.759C161.798 163.096 162.587 163.322 163.488 163.49C165.234 163.828 167.15 163.997 169.121 163.772C171.713 163.49 174.417 162.646 177.064 161.464C180.613 159.887 184.05 157.523 187.092 154.596C187.374 154.37 187.43 153.976 187.205 153.695C186.979 153.413 186.585 153.357 186.303 153.582C183.993 155.102 181.627 156.228 179.149 157.185C176.614 158.199 174.079 158.818 171.6 159.268C170.304 159.493 169.009 159.662 167.826 159.775C166.53 159.944 165.234 160.056 164.051 160.056C162.981 160.056 162.023 160.056 161.066 159.887C159.375 159.662 157.967 159.268 156.84 158.367C156.671 158.199 156.333 158.142 156.164 158.367C156.052 158.649 156.052 158.93 156.221 159.099Z",
    fill: "#0E0B0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_189528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 304,
    fill: "white",
    transform: "translate(60 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZebraOk);
export default __webpack_public_path__ + "static/media/zebra_ok.bfaab4490baced8efb4322fb32874136.svg";
export { ForwardRef as ReactComponent };